import { Pipe, PipeTransform } from '@angular/core';
import { BundleType, EntityTypeId, FieldName, ProviderType, VideoModel } from '../models';
import { MediaPresignApiService } from '../services';
import { Observable, of } from 'rxjs';

@Pipe({
    name: 'videoPresign',
    standalone: false
})

export class VideoMediaPresignPipe implements PipeTransform {
  constructor(private readonly mediaPresignApiService: MediaPresignApiService) { }

  transform(video: Partial<VideoModel> | { file: File }, settingsVideo = false): Observable<string> {
    if (!video) {
      return of('');
    }

    if (this.isFile(video)) {
      const url = window.URL.createObjectURL(video.file);
      return of(url);
    }

    if (video.stream) {
      let entityTypeId = EntityTypeId.MEDIA;
      let bundle = BundleType.VIDEO;

      if (settingsVideo) {
        entityTypeId = EntityTypeId.SETTINGS;
        bundle = BundleType.SETTINGS;
      }

      return this.mediaPresignApiService.getPreSignedUrlCookies(entityTypeId, bundle, FieldName.AWS_VIDEO_STREAM, video);
    }

    if (video.provider === ProviderType.AWS) {
      return this.mediaPresignApiService.getPreSignedUrl(EntityTypeId.MEDIA, BundleType.VIDEO, FieldName.AWS_FILE, video);
    }

    return of(video.uri || video.url);
  }

  protected isFile(video: Partial<VideoModel> | { file: File }): video is { file: File } {
    return 'file' in video && video?.file instanceof File;
  }
}
